export { default } from "@features/investments/screens/equity-detail-screen";
